import { render, staticRenderFns } from "./LikeBtn.vue?vue&type=template&id=6e0632d1&"
import script from "./LikeBtn.vue?vue&type=script&lang=ts&"
export * from "./LikeBtn.vue?vue&type=script&lang=ts&"
import style0 from "./LikeBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
